import { createReducer, createSetter } from "@/redux/helpers/reducer";

import * as actions from "./custom-delivery-docket-print-modal.actions";

const initialState = {
  isPrinting: false,
  isGeneratingPdfStatus: false,
};

export default createReducer(initialState, {
  [actions.setIsPrinting]: createSetter("isPrinting"),
  [actions.setIsGeneratingPdfStatus]: createSetter("isGeneratingPdfStatus"),

  [actions.reset]: () => ({ ...initialState }),
});
